import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var BaseMap = /*#__PURE__*/function () {
  function BaseMap(containerId) {
    _classCallCheck(this, BaseMap);
    this.containerId = containerId;
    this.map = null;
    this._eventMap = new Map(); // 用于存储包装后的事件函数
  }

  // 必须实现的接口
  _createClass(BaseMap, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('Method init() must be implemented');
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      throw new Error('Method destroy() must be implemented');
    }
  }, {
    key: "addOverLay",
    value: function addOverLay() {
      throw new Error('Method addOverlay() must be implemented');
    }
  }, {
    key: "createGeocoder",
    value: function createGeocoder() {
      throw new Error('Method createGeocoder() must be implemented');
    }

    // 元素创建接口
  }, {
    key: "createMarker",
    value: function createMarker(options) {
      throw new Error('Method createMarker() must be implemented');
    }
  }, {
    key: "createInfoWindow",
    value: function createInfoWindow(options) {
      throw new Error('Method createInfoWindow() must be implemented');
    }
  }, {
    key: "createPixel",
    value: function createPixel(options) {
      return new Error('Method createPixel() must be implemented');
    }
  }, {
    key: "openInfoWindow",
    value: function openInfoWindow(marker, infoWindow) {
      throw new Error('Method openInfoWindow() must be implemented');
    }

    // 统一事件接口
  }, {
    key: "on",
    value: function on(target, eventName, handler) {
      throw new Error('Method on() must be implemented');
    }
  }, {
    key: "off",
    value: function off(target, eventName, handler) {
      throw new Error('Method off() must be implemented');
    }
  }]);
  return BaseMap;
}();
export { BaseMap as default };